import React from 'react';
import classNames from 'classnames';
import type { SideNavProps } from './SideNav';
import { SideNavContextProvider } from './SideNavContext';
import SideNavLink from './SideNavLink';
import type { SideNavLinkProps } from './SideNavLink';

export interface SideNavItemProps {
  text: string;
  children?: React.ReactElement<SideNavProps>;
  className?: string;
  current?: boolean;
  href?: string;
  linkComponent?: React.ComponentType<SideNavLinkProps>;
}

const SideNavItem = ({
  text,
  children,
  className,
  current = false,
  href,
  // Make sure the non-intrinsic component name is capitalized.
  // @see https://reactjs.org/docs/jsx-in-depth.html#user-defined-components-must-be-capitalized
  linkComponent: LinkComponent = SideNavLink,
}: SideNavItemProps): JSX.Element => (
  <li className={classNames('usa-sidenav__item', className)}>
    <LinkComponent href={href} current={current}>
      {text}
    </LinkComponent>
    <SideNavContextProvider value={{ isNested: true }}>{children}</SideNavContextProvider>
  </li>
);

export default SideNavItem;
